import { Box, css } from '@mui/material'

import { useMQ } from '../hooks/useMQ'
import { useWindowDimensions } from '../hooks/useWindowDimensions'
import SlantedGradientImg from './images/background-slanted-gradient.png'
import DotImg from './images/background-dot.png'
import NoiseImg from './images/background-noise.png'
import BirdImg from './images/background-bird.png'

export function Background() {
  const { width } = useWindowDimensions()
  const { isSmSize } = useMQ()

  const getHumaBirdStyle = () => {
    if (isSmSize) {
      return css`
        max-width: ${`${(width * 1400 * 1.2) / 1440}px`};
      `
    }
  }

  const styles = {
    slantedGradient: css`
      position: absolute;
      width: ${isSmSize ? '20px' : '1214px'};
      height: ${isSmSize ? '20px' : '837px'};
      top: 0px;
      left: ${isSmSize ? '-20%' : '0%'};
    `,
    noise: css`
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;

      img {
        width: 100%;
        -webkit-mask-image: -webkit-linear-gradient(top, 
          rgba(0,0,0,1) 0%, 
          rgba(0,0,0,.75) 80%, 
          rgba(0,0,0,0) 100%);
        mask-image: linear-gradient(to bottom, 
          rgba(0,0,0,1) 0%, 
          rgba(0,0,0,.75) 80%, 
          rgba(0,0,0,0) 100%);
      }
    `,
    dot: css`
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
    `,
    humaBird: css`
      position: absolute;
      right: ${isSmSize ? '700px' : '0'};
      margin-top: ${isSmSize ? '200px' : '650px'};
      ${getHumaBirdStyle()}
    `,
  }

  return (
    <>
      <Box css={styles.slantedGradient}>
        <img src={SlantedGradientImg} alt='Nebula' />
      </Box>
      <Box css={styles.noise}>
        <img src={NoiseImg} alt='Noise' />
      </Box>
      <Box css={styles.dot}>
        <img src={DotImg} alt='Dot' />
      </Box>
      <Box css={styles.humaBird}>
        <img src={BirdImg} alt='Bird' />
      </Box>
    </>
  )
}
